<template>
  <div class="pay-mortgage__wrapper my-4 my-xl-0 me-xl-4 d-xl-flex align-items-center text-center">
    <modal :modalOptions="options"
           :newWindow="false"
           :dialogClasses="dialogClass"
           @modalMounted="handleMount($event)"
           @leaveLinkClicked="leave"
           @stayLinkClicked="close">
      <template v-slot>
        <div v-html="messageHtml"></div>
      </template>
    </modal>
    <template v-if="submit">
      <form :action="model.Action"
            class="pay-mortgage__form"
            enctype="multipart/form-data"
            method="post">
        <input type="hidden"
               id="HostedKey"
               name="HostedKey"
               :value="model.HostedKey" />
        <input type="hidden"
               id="Gateway_ID"
               name="Gateway_ID"
               :value="model.Gateway_ID" />
        <input type="hidden"
               id="IndustryCode"
               name="IndustryCode"
               :value="model.IndustryCode" />
        <input type="hidden"
               id="Amount"
               name="Amount"
               :value="model.Amount" />
        <input type="hidden"
               id="RecurringType"
               name="RecurringType"
               :value="model.RecurringType" />
        <input type="hidden"
               id="RecurringAmount"
               name="RecurringAmount"
               :value="model.RecurringAmount" />
        <input type="hidden"
               id="RURL"
               name="RURL"
               :value="model.RURL" />
        <input type="hidden"
               id="CURL"
               name="CURL"
               :value="model.CURL" />
        <input type="hidden"
               id="AVSRequired"
               name="AVSRequired"
               :value="model.AVSRequired" />
        <input type="hidden"
               id="CVV2Required"
               name="CVV2Required"
               :value="model.CVV2Required" />
        <input type="hidden"
               id="EmailRequired"
               name="EmailRequired"
               :value="model.EmailRequired" />
        <input type="hidden"
               id="PostRspMsg"
               name="PostRspMsg"
               :value="model.PostRspMsg" />
        <input type="hidden"
               id="SECCode"
               name="SECCode"
               :value="model.SECCode" />
        <input type="hidden"
               id="Descriptor"
               name="Descriptor"
               :value="model.Descriptor" />
      </form>
    </template>
    <a @click="show"
       href="javascript:void(0)"
       class="submit-link">
      Pay My Mortgage
    </a>
  </div>
</template>
<script>
  import { ref, nextTick } from 'vue';
  import { decodeHtml } from '../helpers/html';

  export default {
    name: 'PayMortgageButton',
    props: {
      message: {
        type: String,
        required: true,
      },
      model: {
        type: Object,
        required: true
      }
    },
    setup(props) {
      let modal = undefined;
      const messageHtml = decodeHtml(props.message);
      const dialogClass = 'modal-dialog-centered'
      let submit = ref(false);

      const handleMount = (modalEvent) => {
        modal = modalEvent;
      };

      const show = () => {
        modal.show();
      };

      const leave = async () => {
        submit.value = true;
        await nextTick();
        const form = document.querySelector('.pay-mortgage__form');
        modal.hide();
        form.submit();
      };

      const close = () => {
        modal.hide();
      };

      const options = {
        backdrop: false,
        keyboard: false,
        focus: true
      }

      return {
        show,
        handleMount,
        submit,
        close,
        leave,
        options,
        messageHtml,
        dialogClass
      };
    }
  };
</script>
